import React from "react";
import MastersList from "../components/MastersList";
import BackButton from "../components/BackButton";
import { ReactComponent as ArrowIcon } from "../inlineSvgs/arrow-left.svg";

const SelectMasterPage = ({ displayHead = false }) => {
  return (
    <div>
      {displayHead && (
        <div className="mobile-booking-head">
          <BackButton className="back-btn">
            <ArrowIcon />
          </BackButton>
          <div className="title">Select Master</div>
        </div>
      )}
      <MastersList />
    </div>
  );
};

export default SelectMasterPage;
